<template>
  <div
    :class="classes"
    style="width: header.maxWidth"
  >
    <span>{{ header.title }}</span>
  </div>
</template>

<style>
.header {
  max-width: v-bind(headerMaxWidth);
}
</style>

<script >
import { computed } from '@vue/composition-api'
import TableHeader from '@/models/components/table/TableHeader'

export default {
  props: {
    header: {
      type: TableHeader,
      required: true,
    },
  },

  setup(props) {
    const headerMaxWidth = computed(() => `${props.header.maxWidth}px`)

    const classes = computed(() => {
      let str = 'header'

      if (props.header.align === 'center') {
        str += ' text-center'
      }

      return str
    })

    return {
      headerMaxWidth,
      classes,
    }
  },
}
</script>
